module.exports = __webpack_public_path__ + "fonts/Figtree-SemiBold-59993b8.ttf";